import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import getContrastFontColor from '@utils/getContrastFontColor';
import { Link } from 'shared-routing';

export type HeaderPosition = 'left' | 'centerLeft' | 'centerRight';

const menuHeightLarge = '111px';
const menuHeightMedium = '81px';

export const Header = styled.header<{ headerPosition: HeaderPosition }>`
  background: ${({ theme }) => theme.customColors.header};
  height: ${menuHeightMedium};
  display: flex;
  align-items: center;
  position: relative;
  color: ${({ theme }) =>
    getContrastFontColor(
      theme.customColors.header,
      theme.defaultColors.fontPrimary,
      theme.defaultColors.lighterGrey
    )};

  ${({ headerPosition }) =>
    headerPosition === 'centerLeft' &&
    css`
      --menu-position: flex-start;
    `}

  ${media.md`
    height: ${menuHeightLarge};
  `}
`;

export const ActionButton = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) =>
    getContrastFontColor(
      theme.customColors.header,
      theme.defaultColors.fontPrimary,
      theme.defaultColors.lighterGrey
    )};
  cursor: pointer;

  svg {
    color: inherit;
    margin-right: 2px;
  }
`;

export const DesktopOnly = styled.div`
  display: none;

  ${media.md`
    display: initial;
  `}
`;

export const MobileOnly = styled.div`
  display: initial;

  ${media.md`
    display: none;
  `}
`;

export const StyledLink = styled(Link)`
  min-height: 44px;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
`;
